import { render, staticRenderFns } from "./ezCms1X.vue?vue&type=template&id=0e94b485"
import script from "./ezCms1X.vue?vue&type=script&lang=js"
export * from "./ezCms1X.vue?vue&type=script&lang=js"
import style0 from "./ezCms1X.vue?vue&type=style&index=0&id=0e94b485&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports